import { defineMessages } from 'react-intl'

import { STATUS } from './constants'

export const statusMessages = defineMessages({
  [STATUS.AVAILABLE]: {
    id: 'spaninsh.carts.status.available',
    defaultMessage: 'Disponible'
  },
  [STATUS.OCCUPIED]: {
    id: 'spaninsh.carts.status.occupied',
    defaultMessage: 'En uso'
  }
})
